export const HOME = '/'
export const BECOME_A_MEMBER = '/mcu-become-a-member'
export const CONTACT_US = '/mcu-contact-us'
export const HOLIDAY_SCHEDULE= '/mcu-holiday-schedule'
export const LOAN_RATES = '/mcu-loan-rates'
export const LOAN_APPLICATION = '/mcu-loan-application'
export const DEPOSITE_RATES = '/mcu-deposite-rate'
export const CHECKING_ACCOUNTS = '/mcu-checking-accounts'
export const CREDIT_CARDS = '/mcu-credit-cards'
export const CU_SERVICE = '/mcu-cu-services'
export const ATM_LOCATOR = '/mcu-atm-locators'
export const CALCULATOR = '/mcu-calculator'
export const MAIN_CALCULATOR = '/mcu-cal'
export const PROMOTION = '/mcu-promotions'
export const SITE_MAP = '/mcu-site-map'
export const BECOME_A_MEMBER_FORM = '/mcu-signupform'
export const SUCCESS_LOAN_FORM = '/mcu-secure-forms/loan-application-thanks'











